<template>
  <div style="margin: 10px; height: 600px">
    <v-form direction="horizontal">
      <div style="text-align: left">
        <v-affix :offset-top="10">
          <v-button type="success" icon="save" @click.prevent="save()"
            >保存</v-button
          >
        </v-affix>
      </div>
      <v-form-item
        label="报销科目"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
        required
      >
        <v-select
          style="width: 100%"
          :data="bxkm_options"
          v-model="options.bx_km"
        ></v-select>
      </v-form-item>
      <v-form-item
        label="报销月份"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
        required
      >
        <vxe-input
          style="width: 100%"
          v-model="options.bxyf"
          placeholder="报销月份"
          type="month"
          valueFormat="yyyyMM"
        ></vxe-input>
      </v-form-item>
      <v-form-item
        label="报销金额"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
        required
      >
        <v-input v-model="options.bx_je" placeholder="报销金额"></v-input>
      </v-form-item>
      <v-form-item
        label="报销理由"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
      >
        <v-input v-model="options.bx_ms" placeholder="报销理由"></v-input>
      </v-form-item>
    </v-form>
  </div>
</template>

<script>
let options = {
  id:"",
  bx_km: "",
  bxyf: "",
  bx_je: "",
  bx_ms: "",
};
export default {
  data() {
    return {
      labelCol: {
        span: 6,
      },
      wrapperCol: {
        span: 14,
      },
      bxkm_options: [],
      options,
    };
  },
  created() {
    this.init_bxkm();
    this.init();
  },
  methods: {
    init: function () {
      this.options.id =  this.$route.query.id;
      this.$axios
        .get("api/system/bx/get-bx-first?id=" + this.$route.query.id)
        .then((res) => {
          this.options = res.data;
        });
    },
    
    init_bxkm: function () {
      this.$axios.get("api/system/bx/get-bx-bxkm").then((res) => {
        let self = this;
        self.bxkm_options = res.data.map((item) => {
          return { value: item.km_dm, label: item.km_mc };
        });
      });
    },
    save() {
      if(!this.options.bx_km){
        this.$message["error"]("请选择报销科目！");
        return;
      }
      if(!this.options.bxyf){
        this.$message["error"]("请选择报销月份！");
        return;
      }
      if(!this.options.bx_je){
        this.$message["error"]("请选择报销金额！");
        return;
      }
      let reg = /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/;
      if (!reg.test(this.options.bx_je)) {
        this.$message["error"]("请正确输入金额！");
        return;
      }
      this.$axios
        .post("api/system/bx/update-bx-first", this.options)
        .then((res) => {
          if (res.data.code == 200) {
            this.$message["success"](res.data.message);
            xadmin.close();
            xadmin.father_reload();
          } else {
            this.$message["error"](res.data.message);
          }
        });
    },
    cancel: function () {
      xadmin.close();
    },
  },
};

</script>


<style>
</style>


// WEBPACK FOOTER //
// src/view/bxgl/bxadd.vue